export const WarningBlueBgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="69"
    height="69"
    fill="none"
    viewBox="0 0 69 69">
    <rect
      width="60"
      height="60"
      x="4.5"
      y="4.5"
      fill="#DEF3FF"
      rx="28"></rect>
    <rect
      width="60"
      height="60"
      x="4.5"
      y="4.5"
      stroke="#F1FAFF"
      strokeWidth="8"
      rx="28"></rect>
    <path
      stroke="#0071BC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M34.5 30.75V37M34.5 46.264h-7.575c-4.337 0-6.15-3.1-4.05-6.887l3.9-7.025 3.675-6.6c2.225-4.013 5.875-4.013 8.1 0l3.675 6.612 3.9 7.025c2.1 3.788.275 6.888-4.05 6.888H34.5v-.013zM34.493 40.75h.011"></path>
  </svg>
);
